import common from './common'
import nav from './nav'
const translation = {
    ...common,
    ...{
        nav,
    },
}
export default translation
